import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
export const ModalLoader = () => {
    return (<div className="opacity-75 w-[70px] h-[70px] flex justify-center items-center">
			<LoadingCircles className="sticky top-0 left-0" width={70} height={70}/>
		</div>);
};
